import React from 'react';
import AdSpace from './AdSpace';

const PageLayout = ({ children }) => {
  return (
    /* 1. Removed max-w and px-12 to allow the background to touch the screen edges */
    <main className="flex-grow w-full py-10">
      
      {/* 2. Added px-4 to the grid container instead of the main wrapper 
             so the content has a tiny breathing room on mobile only */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-0 items-start px-0 sm:px-6 xl:px-10">
        
        {/* 3. Main Content: Force 100% width on mobile, and 10/12 on Ultra-wide */}
        <div className="col-span-1 xl:col-span-10 min-w-0 w-full">
          <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
            {children}
          </div>
        </div>

        {/* 4. Sidebar: Only takes up the remaining 2 units on desktop */}
        <aside className="hidden xl:flex xl:col-span-2 flex-col gap-6 sticky top-28 pr-6">
          <div className="bg-white/70 backdrop-blur-md p-3 rounded-[2rem] border border-slate-200 shadow-sm">
             <div className="text-center mb-2">
               <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest text-center block">
                 Advertisement
               </span>
             </div>
             <AdSpace />
          </div>
        </aside>

      </div>
    </main>
  );
};

export default PageLayout;